import { render, staticRenderFns } from "./caijishuoming.vue?vue&type=template&id=6b099f0e&scoped=true&"
import script from "./caijishuoming.vue?vue&type=script&lang=ts&"
export * from "./caijishuoming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b099f0e",
  null
  
)

export default component.exports